import React, { Component } from 'react';
import './App.css';
import { LogoEditor } from './Components/LogoEditor';
import classnames from 'classnames';
import canvg from 'canvg';

class App extends Component {
  constructor() {
    super();
    this.state = {
      darkTheme: true,
      logoSVGBlob: null,
      logoFilename: 'custom-dazn-logo.svg'
    };
  }

  toggleInvertColours = () => {
    this.setState({ darkTheme: !this.state.darkTheme });
    document.body.classList.toggle('inverted');
  };

  handleLogoUpdate = (logoSVGBlob, logoFilename) => {
    this.setState({
      logoSVGBlob,
      logoFilename
    });
  };

  handleExportSVG = () => {
    const logoSVGObjectUrl = window.URL.createObjectURL(this.state.logoSVGBlob);
    const downloadFilename = `${this.state.logoFilename}.svg`;
    let fakeDownloadLink = document.createElement('a');
    fakeDownloadLink.setAttribute('href', logoSVGObjectUrl);
    fakeDownloadLink.setAttribute('download', downloadFilename);
    fakeDownloadLink.style.display = 'none';
    document.body.appendChild(fakeDownloadLink); // Firefox
    fakeDownloadLink.click();
    document.body.removeChild(fakeDownloadLink);
  };

  handleExportPNG = async () => {
    const svgText = await new Response(this.state.logoSVGBlob).text();

    const canvasId = 'canvas';
    canvg(canvasId, svgText);
    const canvas = document.getElementById(canvasId);

    canvas.toBlob(blob => {
      const downloadFilename = `${this.state.logoFilename}.png`;
      const logoPNGObjectUrl = window.URL.createObjectURL(blob);
      let fakeDownloadLink = document.createElement('a');
      fakeDownloadLink.setAttribute('href', logoPNGObjectUrl);
      fakeDownloadLink.setAttribute('download', downloadFilename);
      fakeDownloadLink.style.display = 'none';
      document.body.appendChild(fakeDownloadLink); // Firefox
      fakeDownloadLink.click();
      document.body.removeChild(fakeDownloadLink);
    }, 'image/png');
  };

  render() {
    const appClasses = classnames({
      App: true,
      'App--dark-theme': !this.state.darkTheme
    });

    return (
      <div className={appClasses}>
        <div className="App__header__buttons">
          <button
            onClick={this.toggleInvertColours}
            className="App__header__button App__header__button--theme"
          >
            {this.state.darkTheme ? 'Light theme' : 'Dark theme'}
          </button>
          <button
            onClick={this.handleExportSVG}
            className="App__header__button App__header__button--svg"
          >
            Export SVG
          </button>
          <button
            onClick={this.handleExportPNG}
            className="App__header__button App__header__button--png"
          >
            Export PNG
          </button>
        </div>

        <header className="App__header">
          <h1>make your own logo</h1>
        </header>

        <canvas
          id="canvas"
          width="4000px"
          height="4000px"
          style={{ display: 'none' }}
        />

        <LogoEditor handleLogoUpdate={this.handleLogoUpdate} />

        <footer className="App__footer">
          Please remember that this tool and logos are only for internal use
        </footer>
      </div>
    );
  }
}

export default App;
